export default "__VITE_ASSET__364c2d61__"